import script from "./ToastComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastComponent.vue?vue&type=script&setup=true&lang=js"

import "./ToastComponent.vue?vue&type=style&index=0&id=4718de5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4718de5c"]])

export default __exports__